<template>
    <div v-if="isLoaded && isHaveItem" class="grid grid-cols-2 gap-3.5">
        <CampaignItem
            v-for="(campaign) in campaigns"
            :key="campaign.id"
            :campaign="campaign"
        ></CampaignItem>
    </div>
    <div v-else>
        <div class="grid h-96 content-center">
            <img class="mx-auto h-14" src="../../../../assets/NotItemList/ic_no_privilege_2x.png" alt=""/>
        </div>
    </div>
</template>
<script>
import ModalMixin from '@/mixin/ModalMixin';
//component
import CampaignItem from "./CampaignItem.vue";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";

/**
 * @event onLoaded
 */
export default {
    name: "CampaignList",
    mixins: [ModalMixin],
    components: {
        CampaignItem,
    },
    props: {
        initListConfig:     { type: Object, required: true },
        initFilterConfig:   { type: Object, required: true },
        linkCategory: { type: Boolean, default: false }
    },
    data: function() {
        return {
            listConfig: null,
            filterConfig: null,

            campaigns: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        };
    },
    created: function() {
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;

        if(this.linkCategory === false){
            this.getList();
        }
    },
    methods: {
        reinitList: function(listConfig, listFilter) {
            this.listConfig = listConfig;
            this.filterConfig = listFilter;
            this.campaigns = [];
            this.getList();
        },
        getList: function() {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsCampaign.apiGetCampaign(this.listConfig, this.filterConfig).subscribe({
                    next: (campaigns) => {
                        this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                        //check is there are more campaign.
                        if (campaigns && campaigns.length < this.listConfig.defaultTopAmount) {
                            this.listConfig.isSeeMoreEnable = false;
                        }

                        //reinitialize list if no skip.
                        if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                            this.campaigns = [];
                        }

                        for (let campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            this.campaigns.push(campaign);
                        }

                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = this.campaigns.length > 0
                            ? true
                            : false;

                        resolve();
                        this.$emit('onLoaded');
                    },
                    error: (err) => {
                         this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.listConfig.isSeeMoreEnable = false;
                        this.errorApi(err);

                        this.$emit('onLoaded');
                        resolve();
                    },
                });
            });
        },

        loadMore: async function() {
            console.log('load more list', this.listConfig.isSeeMoreEnable);
            if (!this.listConfig.isSeeMoreEnable || this.isLoading) {
                return;
            }

            this.modal.loadingModal.show();
            await this.getList();
            this.modal.loadingModal.hide();
        },
    },
}
</script>

